// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1B2rK","rightAdornment":"Header_rightAdornment__17m5F"};